import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: translations.it });

export const LanguageProvider = ({ children }) => {
  const detectInitial = () => {
    if (typeof window === "undefined") return "it";
    const saved = window.localStorage.getItem("provalo_lang");
    if (saved && translations[saved]) return saved;
    const nav = (window.navigator.language || "it").slice(0, 2).toLowerCase();
    return translations[nav] ? nav : "it";
  };

  const [lang, setLangState] = useState(detectInitial);

  const setLang = (newLang) => {
    if (!translations[newLang]) return;
    setLangState(newLang);
    try {
      window.localStorage.setItem("provalo_lang", newLang);
    } catch (e) {}
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations.it;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);
